'use strict';

(function () {
    const onChange = (e) => {
        const targetUrl = e.target.getAttribute('data-url')

        if (!targetUrl) return;

        const targetUrlObj = new window.URL(targetUrl, window.location.origin)

        // MVP UPDATE: We now do a hard reload for ALL event types
        // so the server-side preprocess hack catches the new URL.
        if (window.location.pathname !== targetUrlObj.pathname) {
            window.location.assign(targetUrl)
        }
    }

    const onPopState = (e) => {
        if (!(e.state || {}).date)
            return
        // Find the radio matching the popped state and check it
        const matchingRadio = document.querySelector(
            `input[name="selected_event_date"][value="${e.state.date}"]`)

        if (matchingRadio)
            matchingRadio.checked = true;
    }

    const initCheck = () => {
        const radios = Array.from(document.querySelectorAll('input[name="selected_event_date"]'))

        if (!radios.length)
            return

        const currentPath = new window.URL(window.location.href).pathname

        // 1. Did they land on a specific date via the URL?
        let activeRadio = radios.find(r => {
            const urlObj = new window.URL(r.getAttribute('data-url'), window.location.origin)
            return urlObj.pathname === currentPath
        })

        // 2. If no exact URL match, find the smartest default date
        if (!activeRadio) {
            const today = new Date()

            // Format JS Date to YYYY-MM-DD
            const yyyy = today.getFullYear()
            const mm = String(today.getMonth() + 1).padStart(2, '0')
            const dd = String(today.getDate()).padStart(2, '0')
            const todayStr = `${yyyy}-${mm}-${dd}`

            // Find the first date that is >= today, or fallback to the very last date of the event
            activeRadio = radios.find(radio => radio.value >= todayStr)
                || radios[radios.length - 1]
        }

        // Ensure the DOM reflects our selected radio
        activeRadio.checked = true

        const targetUrl = activeRadio.getAttribute('data-url')

        if (!targetUrl)
            return

        const targetUrlObj = new window.URL(targetUrl, window.location.origin)

        // If the paths already match, bail
        if (currentPath === targetUrlObj.pathname)
            return

        const eventType = activeRadio.getAttribute('data-type')

        // Legacy events need a hard redirect to grab the right node from the server
        if (eventType !== 'smart')
            return window.location.replace(targetUrl)

        // Smart events just need a clean history swap without reloading
        window.history.replaceState({ date: activeRadio.value }, '', targetUrl)
    }

    document
        .addEventListener('DOMContentLoaded', () => {
            // 1. Check for URL mismatch on initial load
            initCheck()

            // 2. Bind the user interactions
            const dateRadios = Array.from(document
                .querySelectorAll('input[name="selected_event_date"]'))

            dateRadios
                .forEach(radio => radio.addEventListener('change', onChange))

            window.addEventListener('popstate', onPopState)
        })
})()
